import type { FC } from "react";

import { CreditCardBlockedIcon } from "@jti/brand-icons/credit-card-blocked";
import { useTranslations } from "@jti/ui";

import styles from "./PaymentPageSecureBlock.module.scss";

export const PaymentPageSecureBlock: FC = () => {
  const { __ } = useTranslations();
  return (
    <div data-testid="secureBlock">
      <div className={styles.secureImg}>
        <CreditCardBlockedIcon width="33px" height="33px" />
        <span>{__("cart.checkout.payment.secure_payment.title")}</span>
      </div>
      <div className={styles.secureTxt}>{__("cart.checkout.payment.secure_payment.text")}</div>
    </div>
  );
};
